import * as React from 'react';

import Gateway from '../Gateway';
import { useTranslation } from 'react-i18next';

interface Props {
	onClick: () => void;
}

const Test: React.FC<Props> = ({ onClick }) => {
	const { t } = useTranslation('PaymentForm');

	return <Gateway header={t('Test payment')} onClick={onClick} paymentType={'Test'} />;
};

export default Test;
